'use client';

import { useLocale } from 'next-intl';

export const useClientLocale = (): { locale: string } => {
  const locale = useLocale();

  return { locale };
};
